import { push } from 'connected-react-router'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import NavListItem from './NavListItem'
import { hideModal } from '../../../actions/_modal'
import useLexicon from '../../../hooks/useLexicon'

const NavList = ({
  dispatch,
  auth,
  onItemClick,
  needsMentorDashboardRefresh,
  mentorDashboardNotificationsCount,
  pathname,
  selectedMyStudentsTab
}) => {
  const isMentor = auth.isMentor
  const isGuardian = auth.user.guardian_user ? auth.user.guardian_user : false
  const lexicon = useLexicon()

  const unreadNotificationsCount = useSelector(
    state => state.mycourses.unreadNotificationsCount
  )
  const masterCourseFilterId = useSelector(
    state => state.mycourses.masterCourseFilterId
  )
  const userOnlyHasPastCourses =
    !auth.userHasCurrentCourses && auth.userHasPastCourses

  const navigate = e => {
    dispatch(hideModal())
    dispatch(push(e.currentTarget.dataset.url))
    onItemClick()
  }

  return (
    <ol className="nav-list">
      {isMentor && auth.userHasCurrentCourses && (
        <NavListItem
          pathname={pathname}
          url={`/mystudents/${selectedMyStudentsTab}`}
          text={'My Students'}
          cssClass={'nav-my-students'}
          onClick={navigate}
        />
      )}

      {isMentor &&
        (auth.userHasCurrentCourses || auth.userHasPastCourses) && (
          <NavListItem
            pathname={pathname}
            url={'/mentordashboard'}
            text={'Dashboard'}
            cssClass={'nav-mentor-dashboard'}
            notificationCssClass={'md'}
            onClick={navigate}
            needsRefresh={needsMentorDashboardRefresh}
            notificationsCount={isGuardian ? 0 : mentorDashboardNotificationsCount}
            displayNotificationsCountIfZero
          />
        )}

      {!isMentor && (
        <NavListItem
          pathname={pathname}
          url={`/user/${auth.user.id}/dashboard`}
          text={'My Dashboard'}
          cssClass={'student-dashboard'}
          onClick={navigate}
          notificationCssClass={'my-dashboard'}
          notificationsCount={0}
        />
      )}

      {(auth.userHasCurrentCourses || auth.userHasPastCourses) && (
        <NavListItem
          pathname={pathname}
          url={`/user/${auth.user.id}/courses${
            userOnlyHasPastCourses && isMentor
              ? '/past'
              : ''
          }`}
          text={`My ${lexicon.course}s`}
          cssClass={'student-courses'}
          notificationCssClass={'my-courses'}
          onClick={
            !isMentor
              ? () => {
                  navigate({
                    currentTarget: {
                      dataset: {
                        url: `/user/${auth.user.id}/courses`
                      }
                    }
                  })
                }
              : navigate
          }
          notificationsCount={0}
        />
      )}

      {!isMentor && (
        <NavListItem
          pathname={pathname}
          url={'/engagement'}
          text={`My ${lexicon.engagement}`}
          cssClass={'student-engagement'}
          onClick={navigate}
          notificationCssClass={'my-quests'}
          notificationsCount={0}
        />
      )}

      {!isMentor && (
        <NavListItem
          pathname={pathname}
          url={'/myartifacts'}
          text={`My ${lexicon.artifact}`}
          cssClass={'nav-my-artifacts'}
          onClick={navigate}
        />
      )}

      <NavListItem
        pathname={pathname}
        url={'/mycommunity'}
        text={'My Community'}
        cssClass={'nav-my-community'}
        onClick={navigate}
      />
    </ol>
  )
}

NavList.propTypes = {
  dispatch: PropTypes.func,
  onItemClick: PropTypes.func,
  pathname: PropTypes.string,
  auth: PropTypes.object,
  unreadFeedbackCount: PropTypes.number,
  unreadAssessmentCount: PropTypes.number,
  needsMentorDashboardRefresh: PropTypes.bool,
  mentorDashboardNotificationsCount: PropTypes.number,
  selectedMyStudentsTab: PropTypes.string
}

export default NavList
